// Current-player chip. Rest (`active` false): base bg + dark fg. Pressed (`active` true): dark bg +
// base fg. Treat as pressed when that slot has a value OR the picker/dialog for that slot is open.

import React from 'react';
import { Button } from '@/components/ui/button';
import { usePlayerColorStyle } from '@/hooks/usePlayerColorStyle';
import { cn } from '@/utilities/cn';

export interface PlayerStyledButtonProps extends Omit<
  React.ComponentProps<typeof Button>,
  'variant' | 'size'
> {
  /** Pressed: filled/selected content, or picker open on this chip (inverse colors vs rest). */
  active?: boolean;
}

const PlayerStyledButton = React.forwardRef<
  HTMLButtonElement,
  PlayerStyledButtonProps
>(({ active = false, className, style, ...props }, ref) => {
  const playerPalette = usePlayerColorStyle();

  return (
    <Button
      ref={ref}
      type="button"
      variant="playerColor"
      data-active={active}
      style={{ ...playerPalette, ...style }}
      className={cn(
        'box-border size-14 gap-0 rounded-lg p-0 text-2xl font-bold tabular-nums leading-none sm:size-16',
        '[&_svg]:size-8 sm:[&_svg]:size-10',
        'data-[active=true]:bg-[var(--player-color-dark)] data-[active=true]:text-[var(--player-color-base)] data-[active=true]:hover:bg-[var(--player-color-dark)]/90',
        className
      )}
      {...props}
    />
  );
});

PlayerStyledButton.displayName = 'PlayerStyledButton';

export default PlayerStyledButton;
